import e, { useState as n, useRef as l, useEffect as r } from "react";
function a(e, n) {
  (null == n || n > e.length) && (n = e.length);
  for (var l = 0, r = Array(n); l < n; l++) r[l] = e[l];
  return r;
}
function t(e, n, l) {
  return (n = function (e) {
    var n = function (e, n) {
      if ("object" != typeof e || !e) return e;
      var l = e[Symbol.toPrimitive];
      if (void 0 !== l) {
        var r = l.call(e, n || "default");
        if ("object" != typeof r) return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === n ? String : Number)(e);
    }(e, "string");
    return "symbol" == typeof n ? n : n + "";
  }(n)) in e ? Object.defineProperty(e, n, {
    value: l,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = l, e;
}
function o(e, n) {
  var l = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), l.push.apply(l, r);
  }
  return l;
}
function _(e) {
  for (var n = 1; n < arguments.length; n++) {
    var l = null != arguments[n] ? arguments[n] : {};
    n % 2 ? o(Object(l), !0).forEach(function (n) {
      t(e, n, l[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(l)) : o(Object(l)).forEach(function (n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(l, n));
    });
  }
  return e;
}
function i(e, n) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, n) {
    var l = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != l) {
      var r,
        a,
        t,
        o,
        _ = [],
        i = !0,
        d = !1;
      try {
        if (t = (l = l.call(e)).next, 0 === n) {
          if (Object(l) !== l) return;
          i = !1;
        } else for (; !(i = (r = t.call(l)).done) && (_.push(r.value), _.length !== n); i = !0);
      } catch (e) {
        d = !0, a = e;
      } finally {
        try {
          if (!i && null != l.return && (o = l.return(), Object(o) !== o)) return;
        } finally {
          if (d) throw a;
        }
      }
      return _;
    }
  }(e, n) || c(e, n) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function d(e) {
  return function (e) {
    if (Array.isArray(e)) return a(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || c(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function c(e, n) {
  if (e) {
    if ("string" == typeof e) return a(e, n);
    var l = {}.toString.call(e).slice(8, -1);
    return "Object" === l && e.constructor && (l = e.constructor.name), "Map" === l || "Set" === l ? Array.from(e) : "Arguments" === l || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l) ? a(e, n) : void 0;
  }
}
function u(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var b,
  s = {
    exports: {}
  },
  p = {
    exports: {}
  },
  m = {};
var f,
  T,
  G,
  h,
  y,
  g,
  w,
  v,
  x,
  S,
  O,
  C,
  H,
  k,
  E = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function M() {
  return T || (T = 1, "production" === process.env.NODE_ENV ? p.exports = function () {
    if (b) return m;
    b = 1;
    var e = "function" == typeof Symbol && Symbol.for,
      n = e ? Symbol.for("react.element") : 60103,
      l = e ? Symbol.for("react.portal") : 60106,
      r = e ? Symbol.for("react.fragment") : 60107,
      a = e ? Symbol.for("react.strict_mode") : 60108,
      t = e ? Symbol.for("react.profiler") : 60114,
      o = e ? Symbol.for("react.provider") : 60109,
      _ = e ? Symbol.for("react.context") : 60110,
      i = e ? Symbol.for("react.async_mode") : 60111,
      d = e ? Symbol.for("react.concurrent_mode") : 60111,
      c = e ? Symbol.for("react.forward_ref") : 60112,
      u = e ? Symbol.for("react.suspense") : 60113,
      s = e ? Symbol.for("react.suspense_list") : 60120,
      p = e ? Symbol.for("react.memo") : 60115,
      f = e ? Symbol.for("react.lazy") : 60116,
      T = e ? Symbol.for("react.block") : 60121,
      G = e ? Symbol.for("react.fundamental") : 60117,
      h = e ? Symbol.for("react.responder") : 60118,
      y = e ? Symbol.for("react.scope") : 60119;
    function g(e) {
      if ("object" == typeof e && null !== e) {
        var b = e.$$typeof;
        switch (b) {
          case n:
            switch (e = e.type) {
              case i:
              case d:
              case r:
              case t:
              case a:
              case u:
                return e;
              default:
                switch (e = e && e.$$typeof) {
                  case _:
                  case c:
                  case f:
                  case p:
                  case o:
                    return e;
                  default:
                    return b;
                }
            }
          case l:
            return b;
        }
      }
    }
    function w(e) {
      return g(e) === d;
    }
    return m.AsyncMode = i, m.ConcurrentMode = d, m.ContextConsumer = _, m.ContextProvider = o, m.Element = n, m.ForwardRef = c, m.Fragment = r, m.Lazy = f, m.Memo = p, m.Portal = l, m.Profiler = t, m.StrictMode = a, m.Suspense = u, m.isAsyncMode = function (e) {
      return w(e) || g(e) === i;
    }, m.isConcurrentMode = w, m.isContextConsumer = function (e) {
      return g(e) === _;
    }, m.isContextProvider = function (e) {
      return g(e) === o;
    }, m.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, m.isForwardRef = function (e) {
      return g(e) === c;
    }, m.isFragment = function (e) {
      return g(e) === r;
    }, m.isLazy = function (e) {
      return g(e) === f;
    }, m.isMemo = function (e) {
      return g(e) === p;
    }, m.isPortal = function (e) {
      return g(e) === l;
    }, m.isProfiler = function (e) {
      return g(e) === t;
    }, m.isStrictMode = function (e) {
      return g(e) === a;
    }, m.isSuspense = function (e) {
      return g(e) === u;
    }, m.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === r || e === d || e === t || e === a || e === u || e === s || "object" == typeof e && null !== e && (e.$$typeof === f || e.$$typeof === p || e.$$typeof === o || e.$$typeof === _ || e.$$typeof === c || e.$$typeof === G || e.$$typeof === h || e.$$typeof === y || e.$$typeof === T);
    }, m.typeOf = g, m;
  }() : p.exports = (f || (f = 1, "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
      n = e ? Symbol.for("react.element") : 60103,
      l = e ? Symbol.for("react.portal") : 60106,
      r = e ? Symbol.for("react.fragment") : 60107,
      a = e ? Symbol.for("react.strict_mode") : 60108,
      t = e ? Symbol.for("react.profiler") : 60114,
      o = e ? Symbol.for("react.provider") : 60109,
      _ = e ? Symbol.for("react.context") : 60110,
      i = e ? Symbol.for("react.async_mode") : 60111,
      d = e ? Symbol.for("react.concurrent_mode") : 60111,
      c = e ? Symbol.for("react.forward_ref") : 60112,
      u = e ? Symbol.for("react.suspense") : 60113,
      b = e ? Symbol.for("react.suspense_list") : 60120,
      s = e ? Symbol.for("react.memo") : 60115,
      p = e ? Symbol.for("react.lazy") : 60116,
      m = e ? Symbol.for("react.block") : 60121,
      f = e ? Symbol.for("react.fundamental") : 60117,
      T = e ? Symbol.for("react.responder") : 60118,
      G = e ? Symbol.for("react.scope") : 60119;
    function h(e) {
      if ("object" == typeof e && null !== e) {
        var b = e.$$typeof;
        switch (b) {
          case n:
            var m = e.type;
            switch (m) {
              case i:
              case d:
              case r:
              case t:
              case a:
              case u:
                return m;
              default:
                var f = m && m.$$typeof;
                switch (f) {
                  case _:
                  case c:
                  case p:
                  case s:
                  case o:
                    return f;
                  default:
                    return b;
                }
            }
          case l:
            return b;
        }
      }
    }
    var y = i,
      g = d,
      w = _,
      v = o,
      x = n,
      S = c,
      O = r,
      C = p,
      H = s,
      k = l,
      M = t,
      j = a,
      N = u,
      A = !1;
    function R(e) {
      return h(e) === d;
    }
    E.AsyncMode = y, E.ConcurrentMode = g, E.ContextConsumer = w, E.ContextProvider = v, E.Element = x, E.ForwardRef = S, E.Fragment = O, E.Lazy = C, E.Memo = H, E.Portal = k, E.Profiler = M, E.StrictMode = j, E.Suspense = N, E.isAsyncMode = function (e) {
      return A || (A = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), R(e) || h(e) === i;
    }, E.isConcurrentMode = R, E.isContextConsumer = function (e) {
      return h(e) === _;
    }, E.isContextProvider = function (e) {
      return h(e) === o;
    }, E.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, E.isForwardRef = function (e) {
      return h(e) === c;
    }, E.isFragment = function (e) {
      return h(e) === r;
    }, E.isLazy = function (e) {
      return h(e) === p;
    }, E.isMemo = function (e) {
      return h(e) === s;
    }, E.isPortal = function (e) {
      return h(e) === l;
    }, E.isProfiler = function (e) {
      return h(e) === t;
    }, E.isStrictMode = function (e) {
      return h(e) === a;
    }, E.isSuspense = function (e) {
      return h(e) === u;
    }, E.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === r || e === d || e === t || e === a || e === u || e === b || "object" == typeof e && null !== e && (e.$$typeof === p || e.$$typeof === s || e.$$typeof === o || e.$$typeof === _ || e.$$typeof === c || e.$$typeof === f || e.$$typeof === T || e.$$typeof === G || e.$$typeof === m);
    }, E.typeOf = h;
  }()), E)), p.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
function j() {
  if (h) return G;
  h = 1;
  var e = Object.getOwnPropertySymbols,
    n = Object.prototype.hasOwnProperty,
    l = Object.prototype.propertyIsEnumerable;
  return G = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var n = {}, l = 0; l < 10; l++) n["_" + String.fromCharCode(l)] = l;
      if ("0123456789" !== Object.getOwnPropertyNames(n).map(function (e) {
        return n[e];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        r[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (r, a) {
    for (var t, o, _ = function (e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(r), i = 1; i < arguments.length; i++) {
      for (var d in t = Object(arguments[i])) n.call(t, d) && (_[d] = t[d]);
      if (e) {
        o = e(t);
        for (var c = 0; c < o.length; c++) l.call(t, o[c]) && (_[o[c]] = t[o[c]]);
      }
    }
    return _;
  }, G;
}
function N() {
  if (g) return y;
  g = 1;
  return y = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}
function A() {
  return v ? w : (v = 1, w = Function.call.bind(Object.prototype.hasOwnProperty));
}
if ("production" !== process.env.NODE_ENV) {
  var R = M();
  s.exports = function () {
    if (C) return O;
    C = 1;
    var e = M(),
      n = j(),
      l = N(),
      r = A(),
      a = function () {
        if (S) return x;
        S = 1;
        var e = function e() {};
        if ("production" !== process.env.NODE_ENV) {
          var n = N(),
            l = {},
            r = A();
          e = function e(_e) {
            var n = "Warning: " + _e;
            "undefined" != typeof console && console.error(n);
            try {
              throw new Error(n);
            } catch (e) {}
          };
        }
        function a(a, t, o, _, i) {
          if ("production" !== process.env.NODE_ENV) for (var d in a) if (r(a, d)) {
            var c;
            try {
              if ("function" != typeof a[d]) {
                var u = Error((_ || "React class") + ": " + o + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw u.name = "Invariant Violation", u;
              }
              c = a[d](t, d, _, o, null, n);
            } catch (e) {
              c = e;
            }
            if (!c || c instanceof Error || e((_ || "React class") + ": type specification of " + o + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof c + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), c instanceof Error && !(c.message in l)) {
              l[c.message] = !0;
              var b = i ? i() : "";
              e("Failed " + o + " type: " + c.message + (null != b ? b : ""));
            }
          }
        }
        return a.resetWarningCache = function () {
          "production" !== process.env.NODE_ENV && (l = {});
        }, x = a;
      }(),
      t = function t() {};
    function o() {
      return null;
    }
    return "production" !== process.env.NODE_ENV && (t = function t(e) {
      var n = "Warning: " + e;
      "undefined" != typeof console && console.error(n);
      try {
        throw new Error(n);
      } catch (e) {}
    }), O = function O(_, i) {
      var d = "function" == typeof Symbol && Symbol.iterator,
        c = "<<anonymous>>",
        u = {
          array: m("array"),
          bigint: m("bigint"),
          bool: m("boolean"),
          func: m("function"),
          number: m("number"),
          object: m("object"),
          string: m("string"),
          symbol: m("symbol"),
          any: p(o),
          arrayOf: function arrayOf(e) {
            return p(function (n, r, a, t, o) {
              if ("function" != typeof e) return new s("Property `" + o + "` of component `" + a + "` has invalid PropType notation inside arrayOf.");
              var _ = n[r];
              if (!Array.isArray(_)) return new s("Invalid " + t + " `" + o + "` of type `" + G(_) + "` supplied to `" + a + "`, expected an array.");
              for (var i = 0; i < _.length; i++) {
                var d = e(_, i, a, t, o + "[" + i + "]", l);
                if (d instanceof Error) return d;
              }
              return null;
            });
          },
          element: p(function (e, n, l, r, a) {
            var t = e[n];
            return _(t) ? null : new s("Invalid " + r + " `" + a + "` of type `" + G(t) + "` supplied to `" + l + "`, expected a single ReactElement.");
          }),
          elementType: p(function (n, l, r, a, t) {
            var o = n[l];
            return e.isValidElementType(o) ? null : new s("Invalid " + a + " `" + t + "` of type `" + G(o) + "` supplied to `" + r + "`, expected a single ReactElement type.");
          }),
          instanceOf: function instanceOf(e) {
            return p(function (n, l, r, a, t) {
              if (!(n[l] instanceof e)) {
                var o = e.name || c;
                return new s("Invalid " + a + " `" + t + "` of type `" + ((_ = n[l]).constructor && _.constructor.name ? _.constructor.name : c) + "` supplied to `" + r + "`, expected instance of `" + o + "`.");
              }
              var _;
              return null;
            });
          },
          node: p(function (e, n, l, r, a) {
            return T(e[n]) ? null : new s("Invalid " + r + " `" + a + "` supplied to `" + l + "`, expected a ReactNode.");
          }),
          objectOf: function objectOf(e) {
            return p(function (n, a, t, o, _) {
              if ("function" != typeof e) return new s("Property `" + _ + "` of component `" + t + "` has invalid PropType notation inside objectOf.");
              var i = n[a],
                d = G(i);
              if ("object" !== d) return new s("Invalid " + o + " `" + _ + "` of type `" + d + "` supplied to `" + t + "`, expected an object.");
              for (var c in i) if (r(i, c)) {
                var u = e(i, c, t, o, _ + "." + c, l);
                if (u instanceof Error) return u;
              }
              return null;
            });
          },
          oneOf: function oneOf(e) {
            return Array.isArray(e) ? p(function (n, l, r, a, t) {
              for (var o = n[l], _ = 0; _ < e.length; _++) if (b(o, e[_])) return null;
              var i = JSON.stringify(e, function (e, n) {
                return "symbol" === h(n) ? String(n) : n;
              });
              return new s("Invalid " + a + " `" + t + "` of value `" + String(o) + "` supplied to `" + r + "`, expected one of " + i + ".");
            }) : ("production" !== process.env.NODE_ENV && t(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), o);
          },
          oneOfType: function oneOfType(e) {
            if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && t("Invalid argument supplied to oneOfType, expected an instance of array."), o;
            for (var n = 0; n < e.length; n++) {
              var a = e[n];
              if ("function" != typeof a) return t("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + y(a) + " at index " + n + "."), o;
            }
            return p(function (n, a, t, o, _) {
              for (var i = [], d = 0; d < e.length; d++) {
                var c = (0, e[d])(n, a, t, o, _, l);
                if (null == c) return null;
                c.data && r(c.data, "expectedType") && i.push(c.data.expectedType);
              }
              return new s("Invalid " + o + " `" + _ + "` supplied to `" + t + "`" + (i.length > 0 ? ", expected one of type [" + i.join(", ") + "]" : "") + ".");
            });
          },
          shape: function shape(e) {
            return p(function (n, r, a, t, o) {
              var _ = n[r],
                i = G(_);
              if ("object" !== i) return new s("Invalid " + t + " `" + o + "` of type `" + i + "` supplied to `" + a + "`, expected `object`.");
              for (var d in e) {
                var c = e[d];
                if ("function" != typeof c) return f(a, t, o, d, h(c));
                var u = c(_, d, a, t, o + "." + d, l);
                if (u) return u;
              }
              return null;
            });
          },
          exact: function exact(e) {
            return p(function (a, t, o, _, i) {
              var d = a[t],
                c = G(d);
              if ("object" !== c) return new s("Invalid " + _ + " `" + i + "` of type `" + c + "` supplied to `" + o + "`, expected `object`.");
              var u = n({}, a[t], e);
              for (var b in u) {
                var p = e[b];
                if (r(e, b) && "function" != typeof p) return f(o, _, i, b, h(p));
                if (!p) return new s("Invalid " + _ + " `" + i + "` key `" + b + "` supplied to `" + o + "`.\nBad object: " + JSON.stringify(a[t], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
                var m = p(d, b, o, _, i + "." + b, l);
                if (m) return m;
              }
              return null;
            });
          }
        };
      function b(e, n) {
        return e === n ? 0 !== e || 1 / e == 1 / n : e != e && n != n;
      }
      function s(e, n) {
        this.message = e, this.data = n && "object" == typeof n ? n : {}, this.stack = "";
      }
      function p(e) {
        if ("production" !== process.env.NODE_ENV) var n = {},
          r = 0;
        function a(a, o, _, d, u, b, p) {
          if (d = d || c, b = b || _, p !== l) {
            if (i) {
              var m = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw m.name = "Invariant Violation", m;
            }
            if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
              var f = d + ":" + _;
              !n[f] && r < 3 && (t("You are manually calling a React.PropTypes validation function for the `" + b + "` prop on `" + d + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[f] = !0, r++);
            }
          }
          return null == o[_] ? a ? null === o[_] ? new s("The " + u + " `" + b + "` is marked as required in `" + d + "`, but its value is `null`.") : new s("The " + u + " `" + b + "` is marked as required in `" + d + "`, but its value is `undefined`.") : null : e(o, _, d, u, b);
        }
        var o = a.bind(null, !1);
        return o.isRequired = a.bind(null, !0), o;
      }
      function m(e) {
        return p(function (n, l, r, a, t, o) {
          var _ = n[l];
          return G(_) !== e ? new s("Invalid " + a + " `" + t + "` of type `" + h(_) + "` supplied to `" + r + "`, expected `" + e + "`.", {
            expectedType: e
          }) : null;
        });
      }
      function f(e, n, l, r, a) {
        return new s((e || "React class") + ": " + n + " type `" + l + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + a + "`.");
      }
      function T(e) {
        switch (typeof e) {
          case "number":
          case "string":
          case "undefined":
            return !0;
          case "boolean":
            return !e;
          case "object":
            if (Array.isArray(e)) return e.every(T);
            if (null === e || _(e)) return !0;
            var n = function (e) {
              var n = e && (d && e[d] || e["@@iterator"]);
              if ("function" == typeof n) return n;
            }(e);
            if (!n) return !1;
            var l,
              r = n.call(e);
            if (n !== e.entries) {
              for (; !(l = r.next()).done;) if (!T(l.value)) return !1;
            } else for (; !(l = r.next()).done;) {
              var a = l.value;
              if (a && !T(a[1])) return !1;
            }
            return !0;
          default:
            return !1;
        }
      }
      function G(e) {
        var n = typeof e;
        return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, n) {
          return "symbol" === e || !!n && ("Symbol" === n["@@toStringTag"] || "function" == typeof Symbol && n instanceof Symbol);
        }(n, e) ? "symbol" : n;
      }
      function h(e) {
        if (null == e) return "" + e;
        var n = G(e);
        if ("object" === n) {
          if (e instanceof Date) return "date";
          if (e instanceof RegExp) return "regexp";
        }
        return n;
      }
      function y(e) {
        var n = h(e);
        switch (n) {
          case "array":
          case "object":
            return "an " + n;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + n;
          default:
            return n;
        }
      }
      return s.prototype = Error.prototype, u.checkPropTypes = a, u.resetWarningCache = a.resetWarningCache, u.PropTypes = u, u;
    }, O;
  }()(R.isElement, !0);
} else s.exports = function () {
  if (k) return H;
  k = 1;
  var e = N();
  function n() {}
  function l() {}
  return l.resetWarningCache = n, H = function H() {
    function r(n, l, r, a, t, o) {
      if (o !== e) {
        var _ = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw _.name = "Invariant Violation", _;
      }
    }
    function a() {
      return r;
    }
    r.isRequired = r;
    var t = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: l,
      resetWarningCache: n
    };
    return t.PropTypes = t, t;
  };
}()();
var I = u(s.exports);
function P() {
  for (var e = arguments.length, n = new Array(e), l = 0; l < e; l++) n[l] = arguments[l];
  return n.filter(Boolean).join(" ");
}
function q(e, n) {
  void 0 === n && (n = {});
  var l = n.insertAt;
  if (e && "undefined" != typeof document) {
    var r = document.head || document.getElementsByTagName("head")[0],
      a = document.createElement("style");
    a.type = "text/css", "top" === l && r.firstChild ? r.insertBefore(a, r.firstChild) : r.appendChild(a), a.styleSheet ? a.styleSheet.cssText = e : a.appendChild(document.createTextNode(e));
  }
}
var F = {
  root: "GeneralTable-module_root__LlARO",
  GeneralTable__wrapper: "GeneralTable-module_GeneralTable__wrapper__01qhZ",
  scrollCloud: "GeneralTable-module_scrollCloud__9O62A",
  table_border: "GeneralTable-module_table_border__eCh4j",
  GeneralTable__cont: "GeneralTable-module_GeneralTable__cont__9pp4w",
  record: "GeneralTable-module_record__LgBfH",
  highlight_active: "GeneralTable-module_highlight_active__Iefa-",
  GeneralTable_header: "GeneralTable-module_GeneralTable_header__lsKsX",
  GeneralTable_headerText__wrapper: "GeneralTable-module_GeneralTable_headerText__wrapper__Qt98t",
  GeneralTable_cell: "GeneralTable-module_GeneralTable_cell__RqHSH",
  GeneralTable_cell_content: "GeneralTable-module_GeneralTable_cell_content__IO8KP",
  GeneralTable_header_row: "GeneralTable-module_GeneralTable_header_row__F3TSe",
  sortable_header: "GeneralTable-module_sortable_header__Znxh8",
  sortedAsc_arrow: "GeneralTable-module_sortedAsc_arrow__kwthA",
  sortedDesc_arrow: "GeneralTable-module_sortedDesc_arrow__UfLui",
  GeneralTable_headerText: "GeneralTable-module_GeneralTable_headerText__-v5JN",
  sortHover_line: "GeneralTable-module_sortHover_line__l-XzL",
  sortedDesc_line: "GeneralTable-module_sortedDesc_line__s4Hqj",
  sortedAsc_line: "GeneralTable-module_sortedAsc_line__iRcJO",
  GeneralTable_row: "GeneralTable-module_GeneralTable_row__kj1yf",
  sorted: "GeneralTable-module_sorted__MYgkQ",
  empty_message_row: "GeneralTable-module_empty_message_row__ct16l",
  GeneralTable_row_text_line: "GeneralTable-module_GeneralTable_row_text_line__b2yA8",
  GeneralTable_empty_message: "GeneralTable-module_GeneralTable_empty_message__iHR9P",
  sticky_cell: "GeneralTable-module_sticky_cell__179zE",
  modern: "GeneralTable-module_modern__fSlpi",
  highlight: "GeneralTable-module_highlight__CVtS1"
};
q('.GeneralTable-module_root__LlARO {\n  position: relative;\n}\n\n.GeneralTable-module_GeneralTable__wrapper__01qhZ {\n  overflow-x: scroll;\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n  padding-right: 16px;\n}\n.GeneralTable-module_GeneralTable__wrapper__01qhZ::-webkit-scrollbar {\n  display: none;\n}\n.GeneralTable-module_GeneralTable__wrapper__01qhZ.GeneralTable-module_scrollCloud__9O62A:after {\n  content: " ";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: 16px;\n  height: 100%;\n}\n.GeneralTable-module_GeneralTable__wrapper__01qhZ.GeneralTable-module_table_border__eCh4j {\n  padding: 4px 16px;\n}\n@media (min-width: 768px) {\n  .GeneralTable-module_GeneralTable__wrapper__01qhZ.GeneralTable-module_table_border__eCh4j {\n    border-radius: 4px;\n  }\n}\n\n.GeneralTable-module_GeneralTable__cont__9pp4w {\n  overflow-x: auto;\n  overflow-y: visible;\n  font-family: "urw-din", Helvetica, Arial, sans-serif;\n  width: 100%;\n  border-collapse: collapse;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w caption {\n  text-align: left;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w:not(:last-of-type) {\n  margin-bottom: 16px;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w.GeneralTable-module_record__LgBfH {\n  position: relative;\n  border: none;\n  margin-top: 12px;\n  padding: 0;\n}\n@media only screen and (max-width: 930px) {\n  .GeneralTable-module_GeneralTable__cont__9pp4w.GeneralTable-module_record__LgBfH {\n    width: auto !important;\n  }\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w.GeneralTable-module_highlight_active__Iefa- .GeneralTable-module_GeneralTable_header__lsKsX:first-child .GeneralTable-module_GeneralTable_headerText__wrapper__Qt98t {\n  padding-left: 16px;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w.GeneralTable-module_highlight_active__Iefa- .GeneralTable-module_GeneralTable_header__lsKsX:last-child .GeneralTable-module_GeneralTable_headerText__wrapper__Qt98t {\n  padding-right: 16px;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w.GeneralTable-module_highlight_active__Iefa- .GeneralTable-module_GeneralTable_cell__RqHSH:first-child .GeneralTable-module_GeneralTable_cell_content__IO8KP {\n  padding-left: 16px;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w.GeneralTable-module_highlight_active__Iefa- .GeneralTable-module_GeneralTable_cell__RqHSH:last-child .GeneralTable-module_GeneralTable_cell_content__IO8KP {\n  padding-right: 16px;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe.GeneralTable-module_record__LgBfH {\n  padding: 0;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe:not(:first-of-type) {\n  padding-top: 16px;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_sortable_header__Znxh8 {\n  cursor: pointer;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_GeneralTable_header__lsKsX:first-child {\n  padding-left: 0px;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_GeneralTable_header__lsKsX:last-child {\n  padding-right: 0px;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_GeneralTable_header__lsKsX {\n  padding: 12px 4px;\n  overflow: visible;\n  font-weight: 500;\n  width: var(--cell-width-override-mobile);\n  font-size: 14px;\n  text-transform: uppercase;\n}\n@media (min-width: 768px) {\n  .GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_GeneralTable_header__lsKsX {\n    width: var(--cell-width-override);\n  }\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_sortedAsc_arrow__kwthA,\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_sortedDesc_arrow__UfLui {\n  font-weight: bold;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_GeneralTable_headerText__wrapper__Qt98t {\n  display: flex;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_GeneralTable_headerText__wrapper__Qt98t .GeneralTable-module_GeneralTable_headerText__-v5JN {\n  position: relative;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_GeneralTable_headerText__wrapper__Qt98t .GeneralTable-module_GeneralTable_headerText__-v5JN.GeneralTable-module_record__LgBfH {\n  text-align: left;\n  font: normal normal bold 16px/22px "protipo-narrow";\n  letter-spacing: 0px;\n  opacity: 1;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_GeneralTable_headerText__wrapper__Qt98t .GeneralTable-module_GeneralTable_headerText__-v5JN:after {\n  transition: all 0.2s ease-in-out;\n  opacity: 0;\n  content: " ";\n  position: absolute;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_sortHover_line__l-XzL .GeneralTable-module_GeneralTable_headerText__-v5JN {\n  color: #495057;\n}\n@media (hover: hover) {\n  .GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_sortHover_line__l-XzL .GeneralTable-module_GeneralTable_headerText__-v5JN {\n    cursor: pointer;\n  }\n  .GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_sortHover_line__l-XzL .GeneralTable-module_GeneralTable_headerText__-v5JN:hover {\n    color: #005eb8;\n  }\n  .GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_sortHover_line__l-XzL .GeneralTable-module_GeneralTable_headerText__-v5JN:hover:after {\n    opacity: 1;\n    top: inherit;\n    left: 0;\n    right: 0;\n    width: 100%;\n    bottom: 0;\n    border-bottom: 2px solid #005eb8;\n    border-left: none;\n    border-right: none;\n    border-top: none;\n  }\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_sortedDesc_line__s4Hqj,\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_sortedAsc_line__iRcJO {\n  font-weight: 700;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_sortedDesc_line__s4Hqj .GeneralTable-module_GeneralTable_headerText__-v5JN,\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_sortedAsc_line__iRcJO .GeneralTable-module_GeneralTable_headerText__-v5JN {\n  color: #06192f;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_sortedDesc_line__s4Hqj .GeneralTable-module_GeneralTable_headerText__-v5JN:after,\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_sortedAsc_line__iRcJO .GeneralTable-module_GeneralTable_headerText__-v5JN:after {\n  opacity: 1;\n  top: inherit;\n  left: 0;\n  right: 0;\n  width: 100%;\n  bottom: 0;\n  border-bottom: 2px solid #005eb8;\n  border-left: none;\n  border-right: none;\n  border-top: none;\n}\n@media (hover: hover) {\n  .GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_sortedDesc_line__s4Hqj .GeneralTable-module_GeneralTable_headerText__-v5JN:hover,\n  .GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_sortedAsc_line__iRcJO .GeneralTable-module_GeneralTable_headerText__-v5JN:hover {\n    color: inherit;\n  }\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_sortedAsc_arrow__kwthA .GeneralTable-module_GeneralTable_headerText__-v5JN:after {\n  top: calc(50% - 3px);\n  margin-left: 5px;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 0 5px 5px 5px;\n  border-color: transparent transparent #002b49 transparent;\n  opacity: 1;\n  transform: rotate(0deg);\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_header_row__F3TSe .GeneralTable-module_sortedDesc_arrow__UfLui .GeneralTable-module_GeneralTable_headerText__-v5JN:after {\n  top: calc(50% - 3px);\n  margin-left: 5px;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 0 5px 5px 5px;\n  border-color: transparent transparent #002b49 transparent;\n  opacity: 1;\n  transform: rotate(180deg);\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_row__kj1yf {\n  position: relative;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_row__kj1yf.GeneralTable-module_record__LgBfH {\n  cursor: initial;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_row__kj1yf .GeneralTable-module_GeneralTable_cell__RqHSH:first-child {\n  padding-left: 0px;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_row__kj1yf .GeneralTable-module_GeneralTable_cell__RqHSH:last-child {\n  padding-right: 0px;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_row__kj1yf .GeneralTable-module_GeneralTable_cell__RqHSH {\n  position: relative;\n  font-size: 14px;\n  padding: 10px 4px;\n  overflow: visible;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_row__kj1yf .GeneralTable-module_GeneralTable_cell__RqHSH.GeneralTable-module_sorted__MYgkQ {\n  font-weight: bold;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_row__kj1yf .GeneralTable-module_GeneralTable_cell__RqHSH.GeneralTable-module_record__LgBfH {\n  text-align: center;\n  font: normal normal medium 16px/44px "protipo-narrow";\n  letter-spacing: 0px;\n  opacity: 1;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_row__kj1yf .GeneralTable-module_GeneralTable_cell__RqHSH .GeneralTable-module_GeneralTable_cell_content__IO8KP {\n  display: flex;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_empty_message_row__ct16l {\n  text-align: center;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_row_text_line__b2yA8 > .GeneralTable-module_GeneralTable_cell__RqHSH {\n  color: #495057;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_row_text_line__b2yA8 > .GeneralTable-module_GeneralTable_cell__RqHSH.GeneralTable-module_sorted__MYgkQ {\n  color: #06192f;\n}\n.GeneralTable-module_GeneralTable__cont__9pp4w .GeneralTable-module_GeneralTable_empty_message__iHR9P {\n  font-size: 14px;\n  color: #636a71;\n  text-align: center;\n  padding: 24px 0;\n}\n\n.GeneralTable-module_sticky_cell__179zE {\n  position: sticky !important;\n  left: 0;\n  z-index: 2;\n}\n.GeneralTable-module_sticky_cell__179zE:after {\n  content: " ";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  box-shadow: 5px 14px 11px 0 rgba(0, 0, 0, 0.15);\n}\n\n.GeneralTable-module_modern__fSlpi .GeneralTable-module_highlight__CVtS1 .GeneralTable-module_GeneralTable_cell__RqHSH:first-child .GeneralTable-module_GeneralTable_cell_content__IO8KP {\n  border-radius: 4px 0 0 4px;\n  padding-left: 16px;\n  padding-right: 4px;\n}\n.GeneralTable-module_modern__fSlpi .GeneralTable-module_highlight__CVtS1 .GeneralTable-module_GeneralTable_cell__RqHSH:last-child .GeneralTable-module_GeneralTable_cell_content__IO8KP {\n  border-radius: 0 4px 15px 0;\n  padding-right: 16px;\n  padding-left: 4px;\n}\n.GeneralTable-module_modern__fSlpi .GeneralTable-module_highlight__CVtS1 .GeneralTable-module_GeneralTable_cell__RqHSH:not(:last-child):not(:first-child) .GeneralTable-module_GeneralTable_cell_content__IO8KP {\n  padding-left: 4px;\n  padding-right: 4px;\n}\n.GeneralTable-module_modern__fSlpi .GeneralTable-module_highlight__CVtS1 .GeneralTable-module_GeneralTable_cell__RqHSH {\n  padding: 3px 0 3px 0;\n}\n.GeneralTable-module_modern__fSlpi .GeneralTable-module_highlight__CVtS1 .GeneralTable-module_GeneralTable_cell__RqHSH .GeneralTable-module_GeneralTable_cell_content__IO8KP {\n  font-weight: bold;\n  background-color: #d7e8f9;\n  height: 100%;\n}\n\n@media (prefers-color-scheme: dark) {\n  .GeneralTable-module_GeneralTable__wrapper__01qhZ {\n    border: none !important;\n  }\n  .GeneralTable-module_GeneralTable__wrapper__01qhZ.GeneralTable-module_scrollCloud__9O62A:after {\n    background: none;\n  }\n  .GeneralTable-module_GeneralTable__cont__9pp4w:not(:last-of-type) {\n    border-bottom: 1px solid #495057;\n  }\n  .GeneralTable-module_GeneralTable_header__lsKsX {\n    border-bottom: 1px solid #495057;\n    color: #fff;\n    background-color: #06192f;\n  }\n  .GeneralTable-module_GeneralTable_row__kj1yf:not(:last-of-type) .GeneralTable-module_GeneralTable_cell__RqHSH {\n    border-bottom: 1px solid #495057;\n  }\n  .GeneralTable-module_GeneralTable_cell__RqHSH {\n    color: #fff;\n    background-color: #06192f;\n  }\n  .GeneralTable-module_GeneralTable_cell__RqHSH .GeneralTable-module_GeneralTable_cell_content__IO8KP a {\n    color: #fff;\n  }\n  .GeneralTable-module_modern__fSlpi .GeneralTable-module_highlight__CVtS1 .GeneralTable-module_GeneralTable_cell__RqHSH .GeneralTable-module_GeneralTable_cell_content__IO8KP {\n    color: #06192f;\n    background-color: #fff;\n  }\n  .GeneralTable-module_modern__fSlpi .GeneralTable-module_highlight__CVtS1 .GeneralTable-module_GeneralTable_cell__RqHSH .GeneralTable-module_GeneralTable_cell_content__IO8KP a {\n    color: #06192f;\n  }\n}\n.darkMode .GeneralTable-module_GeneralTable__wrapper__01qhZ {\n  border: none !important;\n}\n.darkMode .GeneralTable-module_GeneralTable__wrapper__01qhZ.GeneralTable-module_scrollCloud__9O62A:after {\n  background: none;\n}\n.darkMode .GeneralTable-module_GeneralTable__cont__9pp4w:not(:last-of-type) {\n  border-bottom: 1px solid #495057;\n}\n.darkMode .GeneralTable-module_GeneralTable_header__lsKsX {\n  border-bottom: 1px solid #495057;\n  color: #fff;\n  background-color: #06192f;\n}\n.darkMode .GeneralTable-module_GeneralTable_row__kj1yf:not(:last-of-type) .GeneralTable-module_GeneralTable_cell__RqHSH {\n  border-bottom: 1px solid #495057;\n}\n.darkMode .GeneralTable-module_GeneralTable_cell__RqHSH {\n  color: #fff;\n  background-color: #06192f;\n}\n.darkMode .GeneralTable-module_GeneralTable_cell__RqHSH .GeneralTable-module_GeneralTable_cell_content__IO8KP a {\n  color: #fff;\n}\n.darkMode .GeneralTable-module_modern__fSlpi .GeneralTable-module_highlight__CVtS1 .GeneralTable-module_GeneralTable_cell__RqHSH .GeneralTable-module_GeneralTable_cell_content__IO8KP {\n  color: #06192f;\n  background-color: #fff;\n}\n.darkMode .GeneralTable-module_modern__fSlpi .GeneralTable-module_highlight__CVtS1 .GeneralTable-module_GeneralTable_cell__RqHSH .GeneralTable-module_GeneralTable_cell_content__IO8KP a {\n  color: #06192f;\n}\n\n@media (prefers-color-scheme: light) {\n  .GeneralTable-module_GeneralTable__wrapper__01qhZ {\n    background-color: #fff;\n  }\n  .GeneralTable-module_GeneralTable__wrapper__01qhZ.GeneralTable-module_scrollCloud__9O62A:after {\n    background: linear-gradient(270deg, #fff 49.48%, rgba(255, 255, 255, 0) 100%);\n  }\n  .GeneralTable-module_GeneralTable__wrapper__01qhZ.GeneralTable-module_table_border__eCh4j {\n    border-top: 1px solid #cecece;\n    border-bottom: 1px solid #cecece;\n  }\n}\n@media (prefers-color-scheme: light) and (min-width: 768px) {\n  .GeneralTable-module_GeneralTable__wrapper__01qhZ.GeneralTable-module_table_border__eCh4j {\n    border: 1px solid #cecece;\n  }\n}\n@media (prefers-color-scheme: light) {\n  .GeneralTable-module_GeneralTable__cont__9pp4w:not(:last-of-type) {\n    border-bottom: 1px solid #cecece;\n  }\n  .GeneralTable-module_GeneralTable_header__lsKsX {\n    border-bottom: 1px solid #cecece;\n    color: #5b6770;\n    background-color: #fff;\n  }\n  .GeneralTable-module_GeneralTable_row__kj1yf:not(:last-of-type) .GeneralTable-module_GeneralTable_cell__RqHSH {\n    border-bottom: 1px solid #cecece;\n  }\n  .GeneralTable-module_GeneralTable_cell__RqHSH {\n    color: #343434;\n    background-color: #fff;\n  }\n  .GeneralTable-module_GeneralTable_cell__RqHSH .GeneralTable-module_GeneralTable_cell_content__IO8KP a {\n    color: #002b49;\n  }\n}\n.lightMode .GeneralTable-module_GeneralTable__wrapper__01qhZ {\n  background-color: #fff;\n}\n.lightMode .GeneralTable-module_GeneralTable__wrapper__01qhZ.GeneralTable-module_scrollCloud__9O62A:after {\n  background: linear-gradient(270deg, #fff 49.48%, rgba(255, 255, 255, 0) 100%);\n}\n.lightMode .GeneralTable-module_GeneralTable__wrapper__01qhZ.GeneralTable-module_table_border__eCh4j {\n  border-top: 1px solid #cecece;\n  border-bottom: 1px solid #cecece;\n}\n@media (min-width: 768px) {\n  .lightMode .GeneralTable-module_GeneralTable__wrapper__01qhZ.GeneralTable-module_table_border__eCh4j {\n    border: 1px solid #cecece;\n  }\n}\n.lightMode .GeneralTable-module_GeneralTable__cont__9pp4w:not(:last-of-type) {\n  border-bottom: 1px solid #cecece;\n}\n.lightMode .GeneralTable-module_GeneralTable_header__lsKsX {\n  border-bottom: 1px solid #cecece;\n  color: #5b6770;\n  background-color: #fff;\n}\n.lightMode .GeneralTable-module_GeneralTable_row__kj1yf:not(:last-of-type) .GeneralTable-module_GeneralTable_cell__RqHSH {\n  border-bottom: 1px solid #cecece;\n}\n.lightMode .GeneralTable-module_GeneralTable_cell__RqHSH {\n  color: #343434;\n  background-color: #fff;\n}\n.lightMode .GeneralTable-module_GeneralTable_cell__RqHSH .GeneralTable-module_GeneralTable_cell_content__IO8KP a {\n  color: #002b49;\n}');
var L = function L(a) {
  var t = a.multiSection,
    o = void 0 !== t && t,
    c = a.data,
    u = void 0 === c ? [] : c,
    b = a.emptyMessage,
    s = a.initialSortSectionIndex,
    p = void 0 === s ? 0 : s,
    m = a.initialSortColumn,
    f = a.sortIconStyle,
    T = void 0 === f ? "arrow" : f,
    G = a.showSortIcon,
    h = void 0 === G || G,
    y = a.columns,
    g = void 0 === y ? [] : y,
    w = a.caption,
    v = void 0 === w ? [] : w,
    x = a.highlightRow,
    S = a.tableFooter,
    O = a.customTableRowStyles,
    C = a.alternatingRowColors,
    H = a.customTableHeaderStyles,
    k = a.customTableStyles,
    E = a.enableSorting,
    M = void 0 !== E && E,
    j = a.tableStyle,
    N = a.minWidth,
    A = a.forceColorScheme,
    R = a.showBorder,
    I = i(n(!1), 2),
    q = I[0],
    L = I[1],
    $ = l(null);
  r(function () {
    if (void 0 !== N) {
      var e = function e() {
          if ($.current) {
            var e = $.current.getBoundingClientRect().width;
            L(e <= N);
          }
        },
        n = new ResizeObserver(e);
      return $.current && n.observe($.current), e(), function () {
        n.disconnect();
      };
    }
  }, []);
  var V = function V(e, n) {
      return n ? e : [e];
    },
    K = function K(e, n, l) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
        a = arguments.length > 4 ? arguments[4] : void 0,
        t = arguments.length > 5 ? arguments[5] : void 0,
        o = d(e);
      return "asc" === l && o[r].sort(function (e, l) {
        return a ? a(e, l) : function (e, n) {
          return e === n ? 0 : null == e ? 1 : null == n || e < n ? -1 : 1;
        }(e[n], l[n]);
      }), "desc" === l && o[r].sort(function (e, l) {
        return t ? t(e, l) : function (e, n) {
          return e === n ? 0 : null == e ? 1 : null == n || e > n ? -1 : 1;
        }(e[n], l[n]);
      }), o;
    },
    D = V(u, o),
    z = V(g, o),
    Z = i(n(function () {
      var e = g.find(function (e) {
          return e.dataKey === m;
        }),
        n = (null == e ? void 0 : e.initialSortDirection) || "desc";
      return K(D, m, n, p, null == e ? void 0 : e.customSortFunctionAscending, null == e ? void 0 : e.customSortFunctionDescending);
    }), 2),
    W = Z[0],
    B = Z[1],
    J = i(n(function () {
      var e = g.find(function (e) {
          return e.dataKey === m;
        }),
        n = (null == e ? void 0 : e.initialSortDirection) || "desc";
      return {
        sectionIndex: p,
        columnKey: m,
        sortOrder: n
      };
    }), 2),
    X = J[0],
    Y = J[1],
    Q = function Q(e) {
      return "top" === e ? "flex-start" : "bottom" === e ? "flex-end" : "center";
    },
    U = {
      minWidth: N && "".concat(N, "px")
    },
    ee = function ee() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        n = e.cellWidthOverride,
        l = e.cellWidthOverrideMobile || e.cellWidthOverride,
        r = {};
      return n && (r["--cell-width-override"] = "".concat(n, "%")), l && (r["--cell-width-override-mobile"] = "".concat(l, "%")), r;
    };
  return e.createElement("div", {
    className: P(F.root, A),
    ref: $
  }, e.createElement("div", {
    className: P(F.GeneralTable__wrapper, q ? F.scrollCloud : null, R ? F.table_border : null)
  }, z.map(function (n, l) {
    return e.createElement("table", {
      key: "table_".concat(l),
      className: "".concat(F.GeneralTable__cont, " ").concat(F[j], " ").concat(x ? F.highlight_active : ""),
      style: _(_({}, U), k)
    }, v[l] && e.createElement("caption", {
      className: F.GeneralTable_row
    }, v[l]), 0 !== n.length && e.createElement("thead", null, e.createElement("tr", {
      className: "".concat(F.GeneralTable_header_row, " ").concat(F[j])
    }, 0 !== n.length && n.map(function (n, r) {
      var a = (null == X ? void 0 : X.sectionIndex) === l && (null == X ? void 0 : X.columnKey) === n.dataKey,
        t = X.sectionIndex !== l || X.columnKey !== n.dataKey ? n.initialSortDirection || "asc" : "asc" === (null == X ? void 0 : X.sortOrder) ? "desc" : "asc",
        o = "sortedDesc_" + T,
        i = "sortedAsc_" + T;
      return e.createElement("th", {
        className: P(F.GeneralTable_header, F[j], F["sortHover_" + T], M && !n.disableSorting ? F.sortable_header : null, a && h ? "desc" === X.sortOrder ? F[o] : F[i] : null, n.sticky && q ? F.sticky_cell : null),
        key: n.title + r,
        style: _(_(_({}, ee(n)), H), {}, {
          textAlign: "".concat(n.textAlign)
        }),
        onClick: M && !n.disableSorting ? function () {
          var e = K(W, n.dataKey, t, l, n.customSortFunctionAscending, n.customSortFunctionDescending);
          B(e), Y({
            sectionIndex: l,
            columnKey: n.dataKey,
            sortOrder: t
          });
        } : null
      }, e.createElement("div", {
        className: "".concat(F.GeneralTable_headerText__wrapper),
        style: {
          justifyContent: n.textAlign
        }
      }, "string" == typeof n.title && e.createElement("div", {
        className: "".concat(F.GeneralTable_headerText, " ").concat(F[j])
      }, n.title), "string" != typeof n.title && "line" === T && e.createElement("div", {
        className: "".concat(F.GeneralTable_headerText, " ").concat(F[j])
      }, e.createElement("span", {
        style: {
          height: "32px"
        }
      }, n.title)), "string" != typeof n.title && "arrow" === T && n.title));
    }))), 0 !== W[l].length ? e.createElement("tbody", null, W[l].map(function (r, a) {
      var t = x && x(r) ? "".concat(F.GeneralTable_row, " ").concat(F.highlight) : "".concat(F.GeneralTable_row);
      return e.createElement("tr", {
        className: "".concat(t, " ").concat(F[j], " ").concat(F["GeneralTable_row_text_" + T]),
        key: r.id
      }, 0 !== n.length && n.map(function (n, t) {
        var o,
          i,
          d,
          c = (null == X ? void 0 : X.sectionIndex) === l && (null == X ? void 0 : X.columnKey) === n.dataKey,
          u = C && C[a % 2],
          b = void 0 !== n.customLabel ? r[n.customLabel] : r[n.dataKey];
        return e.createElement("td", {
          className: P(F.GeneralTable_cell, F[j], c ? F.sorted : null, n.sticky && q ? F.sticky_cell : null),
          key: t,
          style: _(_({
            textAlign: n.textAlign
          }, u ? {
            backgroundColor: u
          } : {}), O)
        }, e.createElement("div", {
          className: "".concat(F.GeneralTable_cell_content),
          style: {
            alignItems: "".concat(Q(n.verticalAlign)),
            alignSelf: "".concat(Q(n.verticalAlign)),
            justifyContent: "".concat((d = n.textAlign, "left" === d ? "flex-start" : "right" === d ? "flex-end" : "center")),
            fontWeight: "".concat(n.bold ? "bold" : null)
          }
        }, (i = o = b) != i || "NaN" === o || null == o ? "-" : o));
      }));
    })) : e.createElement("tbody", null, e.createElement("tr", {
      className: "".concat(F.GeneralTable_row)
    }, e.createElement("td", {
      colSpan: n.length,
      className: P(F.GeneralTable_cell, F.empty_message_row)
    }, b))));
  }), 0 === W.length && e.createElement("div", {
    className: F.GeneralTable_empty_message
  }, b), S && e.createElement("div", {
    className: F.GeneralTable_row,
    key: "footerRow"
  }, S)));
};
L.propTypes = {
  forceColorScheme: I.oneOf(["darkMode", "lightMode", "system"]).isRequired,
  multiSection: I.bool,
  data: I.arrayOf(I.shape({
    title: I.string.isRequired,
    dataKey: I.string.isRequired,
    customLabel: I.string,
    cellWidthOverride: I.number,
    cellWidthOverrideMobile: I.number,
    verticalAlign: I.oneOf(["top", "center", "bottom"]),
    textAlign: I.oneOf(["left", "center", "right"]),
    bold: I.bool
  })),
  emptyMessage: I.string,
  initialSortColumn: I.string,
  initialSortSectionIndex: I.number,
  initialSortReverse: I.bool,
  sortIconStyle: I.oneOf(["arrow", "line"]),
  showSortIcon: I.bool,
  columns: I.array,
  caption: I.array,
  highlightRow: I.func,
  tableFooter: I.element,
  customTableRowStyles: I.object,
  alternatingRowColors: I.array,
  customTableHeaderStyles: I.object,
  customTableStyles: I.object,
  enableSorting: I.bool,
  tableStyle: I.string,
  minWidth: I.number,
  showBorder: I.bool
}, L.defaultProps = {
  multiSection: !1,
  data: [],
  emptyMessage: "No data to display",
  initialSortReverse: !1,
  columns: [],
  caption: [],
  enableSorting: !1,
  tableStyle: "",
  forceColorScheme: "lightMode",
  sortIconStyle: "arrow",
  showBorder: !1
};
var $ = "MedalTable-module_OlympicMedalsTableCondensed_country_cont__nFkhY",
  V = "MedalTable-module_OlympicMedalsTableCondensed_tooltip__gACCa",
  K = "MedalTable-module_OlympicMedalsTableCondensed_country_name__aAHzn",
  D = "MedalTable-module_OlympicMedalsTableCondensed_flag__WBNdY",
  z = "MedalTable-module_OlympicMedalsTableCondensed_footer__uaNOH";
q('.MedalTable-module_OlympicMedalsTableCondensed_country_cont__nFkhY {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.MedalTable-module_OlympicMedalsTableCondensed_tooltip__gACCa {\n  visibility: hidden;\n  width: 120px;\n  background-color: black;\n  color: #fff !important;\n  text-align: center;\n  padding: 5px 0;\n  border-radius: 6px;\n  bottom: 100%;\n  left: 50%;\n  margin-left: -60px;\n  position: absolute;\n  z-index: 1;\n}\n.MedalTable-module_OlympicMedalsTableCondensed_tooltip__gACCa:after {\n  content: " ";\n  position: absolute;\n  top: 100%; /* At the bottom of the tooltip */\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: black transparent transparent transparent;\n}\n\n.MedalTable-module_OlympicMedalsTableCondensed_country_name__aAHzn {\n  margin-left: 8px;\n  position: relative;\n}\n.MedalTable-module_OlympicMedalsTableCondensed_country_name__aAHzn:hover .MedalTable-module_OlympicMedalsTableCondensed_tooltip__gACCa {\n  visibility: visible;\n}\n\n.MedalTable-module_OlympicMedalsTableCondensed_flag__WBNdY {\n  width: 22px;\n  height: 14px;\n  object-fit: cover;\n}\n\n.MedalTable-module_OlympicMedalsTableCondensed_footer__uaNOH {\n  flex: 1;\n  text-align: center;\n  padding: 16px 0 0 0;\n}\n.MedalTable-module_OlympicMedalsTableCondensed_footer__uaNOH a {\n  display: block;\n  font-family: "protipo-narrow";\n  font-weight: 500;\n  font-size: 14px;\n  color: #0d5eb8 !important;\n  font-weight: 500 !important;\n  text-decoration: 1px underline transparent;\n  transition: text-decoration 0.2s ease-in-out;\n}\n@media (hover: hover) {\n  .MedalTable-module_OlympicMedalsTableCondensed_footer__uaNOH a {\n    cursor: pointer;\n  }\n  .MedalTable-module_OlympicMedalsTableCondensed_footer__uaNOH a:hover {\n    text-decoration: 1px underline #0d5eb8;\n  }\n}\n.MedalTable-module_OlympicMedalsTableCondensed_footer__uaNOH a:not(:first-child) {\n  border-top: 1px solid #cecece;\n}\n.MedalTable-module_OlympicMedalsTableCondensed_footer__uaNOH a::after {\n  content: " ";\n  display: inline-block;\n  vertical-align: middle;\n  width: 16px;\n  height: 16px;\n  background: url(\'data:image/svg+xml,<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 3.0022L11.5 8.0022L6.5 13.0022" stroke="%23005EB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n}\n@media (min-width: 360px) {\n  .MedalTable-module_OlympicMedalsTableCondensed_footer__uaNOH a {\n    display: inline;\n  }\n  .MedalTable-module_OlympicMedalsTableCondensed_footer__uaNOH a:not(:first-child) {\n    border-left: 2px solid #cecece;\n    border-top: none;\n  }\n  .MedalTable-module_OlympicMedalsTableCondensed_footer__uaNOH a:first-child {\n    padding-left: 0;\n  }\n  .MedalTable-module_OlympicMedalsTableCondensed_footer__uaNOH a:last-child {\n    padding-right: 0;\n  }\n}');
var Z = function Z() {
    return e.createElement("svg", {
      width: "25",
      height: "24",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, e.createElement("path", {
      d: "M0.5 0H9.79032L17.5323 11.2258H8.24194L0.5 0Z",
      fill: "#06192F"
    }), e.createElement("path", {
      d: "M24.5 0H15.2097L7.46774 11.2258H16.7581L24.5 0Z",
      fill: "#06192F"
    }), e.createElement("circle", {
      cx: "12",
      cy: "14.5",
      r: "9.5",
      fill: "#8C5F0C"
    }), e.createElement("path", {
      d: "M12.7 18.5H9.34003V10.064H12.256C13.84 10.064 14.668 10.652 14.668 11.852V12.392C14.668 13.256 14.152 13.772 13.42 14V14.036C14.428 14.192 15.124 14.744 15.124 15.788V16.52C15.124 18.032 13.936 18.5 12.7 18.5ZM11.944 11.36H10.864V13.508H11.884C12.748 13.508 13.132 13.076 13.132 12.56V12.164C13.132 11.576 12.748 11.36 11.944 11.36ZM12.172 14.78H10.864V17.192H12.076C12.94 17.192 13.528 17.012 13.528 16.232V15.764C13.528 15.2 13.132 14.78 12.172 14.78Z",
      fill: "white"
    }));
  },
  W = function W() {
    return e.createElement("svg", {
      width: "25",
      height: "24",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, e.createElement("path", {
      d: "M0.5 0H9.79032L17.5323 11.2258H8.24194L0.5 0Z",
      fill: "#06192F"
    }), e.createElement("path", {
      d: "M24.5 0H15.2097L7.46774 11.2258H16.7581L24.5 0Z",
      fill: "#06192F"
    }), e.createElement("circle", {
      cx: "12",
      cy: "14.5",
      r: "9.5",
      fill: "#717A83"
    }), e.createElement("path", {
      d: "M14.8471 16.04C14.8471 17.552 13.9831 18.704 11.8951 18.704C9.65114 18.704 9.18314 17.684 9.18314 16.868V15.944L10.6831 15.872V16.496C10.6831 17.012 10.9351 17.42 11.9311 17.42C12.4471 17.42 12.7951 17.288 12.9751 17.024C13.1551 16.772 13.2391 16.472 13.2391 16.148C13.2271 15.476 12.9271 15.164 12.1951 14.912L10.9351 14.468C9.77114 14.072 9.19514 13.376 9.19514 12.212C9.19514 11.54 9.42314 10.976 9.87914 10.532C10.3231 10.088 11.0551 9.86 12.0751 9.86C14.1031 9.86 14.6791 10.784 14.6791 11.636V12.596L13.2271 12.644V11.96C13.2271 11.516 12.9511 11.06 12.0511 11.06C11.1511 11.06 10.8031 11.504 10.7911 12.092C10.7791 12.716 11.1391 13.04 11.8471 13.292L13.0591 13.7C14.1991 14.096 14.8471 14.696 14.8471 16.04Z",
      fill: "white"
    }));
  },
  B = function B() {
    return e.createElement("svg", {
      width: "25",
      height: "24",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, e.createElement("path", {
      d: "M0.5 0H9.79032L17.5323 11.2258H8.24194L0.5 0Z",
      fill: "#06192F"
    }), e.createElement("path", {
      d: "M24.5 0H15.2097L7.46774 11.2258H16.7581L24.5 0Z",
      fill: "#06192F"
    }), e.createElement("circle", {
      cx: "12",
      cy: "14.5",
      r: "9.5",
      fill: "#FFC931"
    }), e.createElement("path", {
      d: "M13.6333 15.392H11.8453V14.132H15.0733V18.5H14.1973L14.0293 17.756C13.5373 18.296 12.8173 18.704 11.8093 18.704C9.60127 18.704 8.92927 17.408 8.92927 15.776V12.908C8.92927 11.408 9.72127 9.86 12.1333 9.86C14.4373 9.86 15.0493 11.216 15.0493 12.332V12.896L13.5013 12.968V12.404C13.5013 12.092 13.4053 11.816 13.2133 11.564C13.0213 11.312 12.6493 11.192 12.0973 11.192C11.0053 11.192 10.5373 11.804 10.5373 12.8V15.74C10.5373 16.856 10.9693 17.396 12.0253 17.396C12.6013 17.396 13.0093 17.24 13.2613 16.94C13.5133 16.64 13.6333 16.316 13.6333 15.944V15.392Z",
      fill: "#06192F"
    }));
  },
  J = function J(l) {
    var a = l.year,
      t = l.maxWidth,
      o = l.footerLinks,
      d = void 0 === o ? [] : o,
      c = l.enableBorder,
      u = i(n([]), 2),
      b = u[0],
      s = u[1],
      p = i(n("Loading..."), 2),
      m = p[0],
      f = p[1];
    r(function () {
      var e = "https://stats-api.sportsnet.ca";
      void 0 !== window && (["localhost", "int-www.sportsnet.ca"].includes(window.location.hostname) ? e = "https://int-stats-api.sportsnet.ca" : window.location.hostname.includes("staging") && (e = "https://staging-stats-api.sportsnet.ca")), fetch("".concat(e, "/web_standings?league=OLY&season_year=").concat(a)).then(function (e) {
        return e.json();
      }).then(function (e) {
        var n = e.data.teams;
        if (0 === e.data.teams.length) s([{
          league_rank: null,
          name: null,
          short_name: null,
          gold: null,
          silver: null,
          bronze: null,
          total: null,
          flag_url: null
        }, {
          league_rank: null,
          name: null,
          short_name: null,
          gold: null,
          silver: null,
          bronze: null,
          total: null,
          flag_url: null
        }, {
          league_rank: null,
          name: null,
          short_name: null,
          gold: null,
          silver: null,
          bronze: null,
          total: null,
          flag_url: null
        }, {
          league_rank: null,
          name: null,
          short_name: null,
          gold: null,
          silver: null,
          bronze: null,
          total: null,
          flag_url: null
        }]);else {
          var l = n.sort(function (e, n) {
              return e.league_rank - n.league_rank;
            }),
            r = l.findIndex(function (e) {
              return "Canada" === e.name;
            }),
            a = [];
          if (r < 3) a = l.slice(0, 3);else if (r > 3) {
            var t = l[r];
            l.splice(3, 0, t), a = l.slice(0, 4);
          } else 3 === r && (a = l.slice(0, 4));
          var o = a.map(function (e) {
            return _(_({}, e), {}, {
              customLabel: T(e.name, e.short_name, e.flag_url)
            });
          });
          s(o);
        }
        f("No Medal Information Available.");
      }).catch(function () {
        f("Error Loading Medal Information.");
      });
    }, []);
    var T = function T(n, l, r) {
        return e.createElement("div", {
          className: $
        }, e.createElement("img", {
          className: D,
          src: r,
          alt: "".concat(n, " flag")
        }), e.createElement("div", {
          className: K
        }, l, e.createElement("span", {
          className: V
        }, n)));
      },
      G = function G(n) {
        switch (n) {
          case "bronze":
            return e.createElement(Z, null);
          case "silver":
            return e.createElement(W, null);
          case "gold":
            return e.createElement(B, null);
          default:
            return null;
        }
      };
    return b.length > 0 && e.createElement("div", null, e.createElement(L, {
      maxWidth: t,
      data: b,
      columns: [{
        title: "POS",
        dataKey: "league_rank",
        bold: !1,
        textAlign: "center",
        cellWidthOverride: 12.5,
        initialSortDirection: "asc"
      }, {
        title: "NAME",
        dataKey: "name",
        customLabel: "customLabel",
        bold: !1,
        textAlign: "left",
        cellWidthOverride: 37.5
      }, {
        title: G("gold"),
        dataKey: "gold",
        bold: !1,
        textAlign: "center",
        cellWidthOverride: 12.5
      }, {
        title: G("silver"),
        dataKey: "silver",
        bold: !1,
        textAlign: "center",
        cellWidthOverride: 12.5
      }, {
        title: G("bronze"),
        dataKey: "bronze",
        bold: !1,
        textAlign: "center",
        cellWidthOverride: 12.5
      }, {
        title: "TOT",
        dataKey: "total",
        bold: !1,
        cellWidthOverride: 12.5,
        textAlign: "center"
      }],
      customTableHeaderStyles: {
        color: "#06192F",
        fontFamily: "protipo-narrow, sans-serif",
        margintop: 0,
        fontSize: "14px",
        padding: "0",
        height: "32px",
        lineHeight: "32px",
        bottom: "0px"
      },
      customTableStyles: {
        color: "#495057",
        fontFamily: "protipo-narrow, sans-serif",
        padding: c ? "16px" : "0",
        borderRadius: "8px",
        border: c ? "1px solid #CED4DA" : "none"
      },
      customTableRowStyles: {
        color: "#495057"
      },
      emptyMessage: m,
      tableFooter: d.length ? e.createElement("div", {
        className: z
      }, d.map(function (n, l) {
        return e.createElement("a", {
          key: l,
          href: n.url
        }, n.text);
      })) : null,
      enableSorting: !0,
      sortIconStyle: "line",
      initialSortColumn: "league_rank"
    }));
  };
J.propTypes = {
  year: I.number,
  maxWidth: I.number,
  footerLinks: I.array,
  enableBorder: I.bool
}, J.defaultProps = {
  enableBorder: !0,
  year: 2024,
  footerLinks: [{
    url: "/olympics/medal-table/2024",
    text: "View all olympic medal standings"
  }]
};
export { J as MedalTable, J as default };